export default __webpack_public_path__ + "static/media/credits_icon.0f63f878.png";